import React, { Component } from "react";
import WodForm from "../components/wod/WorkOrders";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { app, timeservice } from "../index";
import CreateDerivative from "../components/wod/derivativemodal";
import { getpath } from "../actions/get-path";
import { modalhandler } from "../actions/modal-handler";
import moment from "moment";
import { datapop } from "../actions/data-populate";
import RelatedWods from "../components/wod/relatedwods";
import {
  deleteservice,
  getservice,
  grabservice,
} from "../services/crudservice";
import FileModal from "../components/wod/filemodal";
import WodRemaining from "../services/wodremaining";
import { genwonumdrop, gendropdown } from "../services/gendropdown";
import { hashHistory } from "react-router";
import MatEntryModal from "../components/shared-components/matentrymodal";
import INVListModal from "../components/wod/invlistmodal.jsx";
import Assignments from "../components/shared-components/assignmentmanager";
import TMListModal from "../components/wod/tnmlistmodal.jsx";
class WorkOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wod: null,
      similarwods: [],
      newwonum: null,
      customer: null,
      labor: [],
      pms: [],
      billing: [],
      chargereport: [],
      company: [],
      location: [],
      program: [],
      reservewod: null,
      wodindex: null,
      totalcharges: 0,
      deriv_charges: [],
      newwodderiv: null,
      newderivcreate: false,
      showWodSearch: props.params.wonum === undefined,
    };
  }

  // gendropdown(key, service, text, value, stateparam) {
  componentDidUpdate(prevProps, prevState) {
    this.props.datapop("jtadmin", "AccessRequest");
    // this.populatewod();
    // if (
    //   this.state.wod &&
    //   this.props.wods[this.state.wodindex] !== this.state.wod &&
    //   this.getwodindex(this.state.wod.workOrderNbr) > -1
    // ) {
    //   // this.setState({ wod: this.props.wods[this.state.wodindex] });
    // }
  }
  gencharges(workOrderNbr) {
    this.timeservice = timeservice
      .find({
        query: {
          workordernumber: workOrderNbr,
        },
      })
      .then((response) => {
        let total = 0;
        let mattotal = 0;
        if (response.length) {
          total = response
            .map((item) => item.hours * parseFloat(item.payrate))
            .reduce((prev, next) => prev + next);
          if (
            this.state.wod.dailymaterialentries &&
            this.state.wod.dailymaterialentries.length
          ) {
            let mats = Array.isArray(this.state.wod.dailymaterialentries)
              ? this.state.wod.dailymaterialentries
              : [this.state.wod.dailymaterialentries];
            mattotal = mats
              .map((mat) =>
                mat.markuppercent
                  ? mat.amount * (mat.markuppercent / 100 + 1)
                  : mat.amount
              )
              .reduce((a, b) => a + b);
          }
        }

        this.setState({ totalcharges: total + mattotal });
      });
  }
  componentDidMount() {
    this.populatewod();
    this.props.getpath("Work Orders", "tasks");
    this.gendropdown("code", "location", "description", "code", "location");
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.params.wonum &&
      this.props.params.wonum != nextProps.params.wonum
    ) {
      console.log("new wo num", nextProps.params.wonum);
      if (this.props.wods.length) {
        this.handlewodselect(nextProps.params.wonum);
        //    this.refs.relatedwods.findsimilarwods();
      }
    }
  }

  populatewod() {
    let wonum = this.props.params.wonum;
    console.log("new wo num", wonum);

    if (
      this.props.wods &&
      !this.state.wod &&
      wonum &&
      this.props.employees.length
    ) {
      let windex = this.props.wods.findIndex((i) => i.workOrderNbr === wonum);

      console.log(windex);
      if (windex > -1) {
        this.handlewodselect(wonum);
      }
    }
  }
  genchargereport(wod = this.state.wod) {
    var chargearray = [];
    let chargereport = [];
    var chargeTotal = 0;
    chargearray = wod.dailylaborentries.concat(wod.dailymaterialentries);

    chargearray.map((entry, index) => {
      if (entry.empname && entry.hours > 0) {
        let entryCharge = entry.hours * entry.payrate;
        chargeTotal += entryCharge;
        let reportindex = chargereport.findIndex(
          (charge) =>
            charge.empnumber === entry.empnumber &&
            charge.rate === entry.payrate
        );
        if (reportindex > -1) {
          chargereport[reportindex] = {
            ...chargereport[reportindex],
            hours: chargereport[reportindex].hours + entry.hours,
            charged: chargereport[reportindex].charged + entryCharge,
          };
        } else {
          let empinfo = this.props.employees.find(
            (emp) => emp.empnumber === entry.empnumber
          );
          chargereport = chargereport.concat({
            empnumber: entry.empnumber,
            discipline: empinfo.discipline,
            name: entry.empname,
            rate: entry.payrate,
            hours: entry.hours,
            charged: entryCharge,
          });
        }
      } else if (entry.matname) {
        let matindex = chargereport.findIndex(
          (charge) => charge.matnumber === entry.matnumber
        );
        let mat_markup_price = entry.amount * entry.markuppercent;
        chargeTotal += mat_markup_price;
        if (matindex > -1) {
          chargereport[matindex] = {
            ...chargereport[matindex],
            charged: chargereport[matindex].charged + mat_markup_price,
          };
        } else {
          chargereport = chargereport.concat({
            matnumber: entry.matnumber,
            discipline: "-",
            name: entry.matname,
            rate: "-",
            hours: "-",
            charged: mat_markup_price,
          });
        }
      }
      if (index + 1 === chargearray.length) {
        chargereport = chargereport.concat({
          discipline: "-",
          name: "Total",
          rate: "-",
          hours: "-",
          charged: chargeTotal,
        });
      }
    });
    if (wod.workOrderNbr === this.state.wod.workOrderNbr) {
      this.setState({ chargereport });
    } else {
      return chargereport;
    }
  }
  genchargeArray() {
    //this function makes a new fancy
    //table that details all charges for all derivatives.
    this.setState({ deriv_charges: [] });
    if (this.state.wod && this.state.wod.workOrderNbr.length === 7) {
      var likederivs = this.props.wods.filter(
        (wod) =>
          wod.workOrderNbr.slice(0, 7) === this.state.wod.workOrderNbr &&
          wod.workOrderNbr !== this.state.wod.workOrderNbr
      );
      if (likederivs.length) {
        var labor_entries = [];
        grabservice("dailylaborentries")
          .then((labor) => (labor_entries = labor))
          .then(() => grabservice("dailymaterialentries"))
          .then((mat_entries) => {
            var total = {
              workOrderNbr: "Total",
              description: "-",
              dailylaborentries: labor_entries.filter(
                (le) =>
                  le.workordernumber.slice(0, 7) ===
                  this.state.wod.workOrderNbr.slice(0, 7)
              ),
              dailymaterialentries: mat_entries.filter(
                (me) =>
                  me.workordernumber.slice(0, 7) ===
                  this.state.wod.workOrderNbr.slice(0, 7)
              ),
            };
            total.charge_report = this.genchargereport(total);
            let deriv_charges = likederivs.map((d) => {
              d.dailylaborentries = labor_entries.filter(
                (le) => le.workordernumber === d.workOrderNbr
              );

              d.dailymaterialentries = mat_entries.filter(
                (me) => me.workordernumber === d.workOrderNbr
              );
              return {
                ...d,
                charge_report: this.genchargereport(d),
              };
            });
            deriv_charges = deriv_charges.concat(total);
            this.setState({ deriv_charges });
          });
      }
    }
  }
  gendropdown(key, service, text, value, stateparam) {
    var currentoptions = [];
    app
      .service(service)
      .find()
      .then((results) => {
        results.map((result) => {
          let newoption = {
            key: result[key],
            value: result[value],
            text: result[text],
          };
          currentoptions.push(newoption);
        });
        this.setState({ [stateparam]: currentoptions });
      });
  }

  handlecreatederiv(derivbudget) {
    let newderiv = this.state.newwodderiv.workOrderNbr;
    let newderivobj = this.state.newwodderiv;
    newderivobj.createDate = moment().format("YYYY-MM-DD");
    newderivobj.budget = derivbudget;
    let rootwod = newderiv.slice(0, 7);

    let wodservice = app.service("workorders");
    wodservice.get(rootwod).then((rw) => {
      rw.derivBudget += derivbudget;
      wodservice.patch(rootwod, { derivBudget: rw.derivBudget });
    });
    wodservice.create(newderivobj).then((response) => {
      console.log("Wod Deriv Response", response);
      this.refs.derivmodal.setState({
        created: true,
        newwonton: response.workOrderNbr,
      });
    });
  }
  handlepatch(param, value) {
    console.log(param + " " + value);
    app
      .service("workorders")
      .patch(this.state.wod.workOrderNbr, { [param]: value })
      .then((response) => console.log(response));
    this.refs.wodform.setState({ editing: false });
  }
  handlesave(savedwod) {
    app
      .service("workorders")
      .update(savedwod.workOrderNbr, savedwod)
      .then((response) => {
        console.log(response);
      });
  }

  getnextderiv() {
    if (this.state.wod && this.state.wod.workOrderNbr) {
      var rootwod = this.state.wod.workOrderNbr.slice(0, 7);
      app
        .service("workorders")
        .find({
          query: { workOrderNbr: rootwod, description: "newderivative" },
        })
        .then((response) => {
          response.remaining = WodRemaining(response);
          console.log("New Wod", response);

          this.setState({ newwodderiv: response });
          this.refs.derivmodal.setState({
            showModal: true,
            maxbudget: response.budget,
            newderivative: response.workOrderNbr,
          });
        });
    }
  }

  getstuff(param, value, service, stateparam) {
    app
      .service(service)
      .find({ query: { [param]: value } })
      .then((results) => {
        results.data.map((result) => this.setState({ [stateparam]: result }));
      });
  }
  getdropdownvalue(queryvalue, queryparam, key, textfield, stateparam) {
    this.props.wods.map((wod) => {
      if (queryvalue === wod[queryparam]) {
        let newdropval = {
          key: wod[key],
          value: queryvalue,
          text: wod[textfield],
        };
        this.setState({ [stateparam]: newdropval });
      }
    });
  }
  getwodindex(wonum) {
    return this.props.wods.findIndex((i) => i.workOrderNbr === wonum);
  }
  handlewodselect(wonum) {
    if (this.state.wod && wonum !== this.state.wod.workOrderNbr) {
    }
    this.props.handlemodal("none");
    app
      .service("workorders")
      .get(wonum)
      .then((newwod) => {
        console.log("This is the New Wod!!!", newwod);
        newwod.remaining = WodRemaining(newwod);
        if (this.state.wod && wonum === this.state.wod.workOrderNbr) {
          getservice("workorders", wonum).then((wod) =>
            this.assignwod({ ...wod, remaining: WodRemaining(wod) })
          );
        } else {
          this.assignwod(newwod);
        }
      });
  }
  refreshWod() {
    if (this.state.wod && this.state.wod.workOrderNbr) {
      getservice("workorders", this.state.wod.workOrderNbr).then((wod) =>
        this.assignwod({ ...wod, remaining: WodRemaining(wod) })
      );
    }
  }
  assignwod(newwod) {
    let similarwods = this.props.wods.filter(
      (wod) => wod.workOrderNbr.slice(0, 7) == newwod.workOrderNbr.slice(0, 7)
    );

    this.setState(
      {
        similarwods,
        showWodSearch: false,
        wod: newwod,
        reservewod: newwod,
        newwonum: null,
      },
      () => {
        console.log("got new wod", this.state.wod);
        this.getrootwod();
        this.genchargereport();
        this.gencharges(newwod.workOrderNbr);
        this.genchargeArray();
      }
    );
  }
  getrootwod(){
    if(this.state.wod.workOrderNbr.length > 7){
      app.service('workorders').get(this.state.wod.workOrderNbr.slice(0, 7)).then(rootwod => this.setState({rootwod}))
    }else{
      this.setState({rootwod: Object.assign(this.state.wod)})
    }
  }
  genwodform(assignments, tmstatus, invstatus) {
    if (this.state.wod) {
      let wodoptions = genwonumdrop(this.props.wods);
      return (
        <WodForm
          deletewod={() => {
            let wonum = this.state.wod.workOrderNbr;
            deleteservice("workorders", wonum);
            if (wonum.length > 7) {
              hashHistory.push("/work-orders/" + wonum.slice(0, 7));
            } else {
              hashHistory.push("/work-orders");
            }
            window.location.reload();
          }}
          tmstatus={this.state.wod.tmsheets && this.state.wod.tmsheets.length}
          wodoptions={wodoptions}
          handlepatch={(param, value) => this.handlepatch(param, value)}
          handlesave={(newwod) => {
            this.handlesave(newwod);
          }}
          deriv_charges={this.state.deriv_charges}
          removeAssigned={() => {
            var unassign_employees = Promise.all(
              this.state.wod.assigned.map((ass) =>
                app.service("assign").patch(ass.id, {
                  removeddate: moment().format("YYYY-MM-DD"),
                  removed: true,
                })
              )
            );
            unassign_employees.then(
              getservice(
                "workorders",
                this.state.wod.workOrderNbr
              ).then((wod) => this.assignwod(wod))
            );
          }}
          totalcharges={this.state.totalcharges}
          handlereset={() => {
            this.handlesave(this.state.reservewod);
          }}
          createderivative={() => {
            this.getnextderiv();
          }}
          undeletable={
            assignments.length ||
            (this.state.wod.dailylaborentries &&
              this.state.wod.dailylaborentries.length) ||
            (this.state.wod.dailymaterialentries &&
              this.state.wod.dailymaterialentries.length)
          }
          chargereport={this.state.chargereport}
          relatedwods={(status) => {
            this.refs.relatedwods.setState({ showModal: status });
          }}
          invenabled={this.state.wod.invoices && this.state.wod.invoices.length}
          handlemodal={(modal) => this.props.handlemodal(modal)}
          program={gendropdown(
            "program",
            "program",
            "program",
            this.props.programs
          )}
          billing={gendropdown("id", "companyname1", "id", this.props.billing)}
          pms={gendropdown(
            "defnumber",
            "contactname",
            "contactname",
            this.props.pms
          )}
          myinfo={this.props.myinfo}
          wod={this.state.wod}
          labor={this.state.labor}
          customer={this.state.customer}
          location={gendropdown(
            "code",
            "description",
            "code",
            this.props.locations
          )}
          companies={this.state.company}
          ref="wodform"
        />
      );
    }
  }
  render() {
    console.log("trying to render", this.state.wod, this.props.myinfo);
    if (this.state.wod && this.props.myinfo) {
      let rootwod = this.props.wods.find(
        (w) => w.workOrderNbr === this.state.wod.workOrderNbr.slice(0, 7)
      );
      let wod = this.state.wod;
      console.log(this.state.wod.dailymaterialentries);
      let assignments = this.props.assign.filter(
        (ass) => ass.assigned_task === this.state.wod.workOrderNbr
      );
      let invoices = this.props.invoices.filter(
        (inv) =>
          inv.workordernumber.slice(0, 7) ===
          this.state.wod.workOrderNbr.slice(0, 7)
      );

      return (
        <div className="WorkOrders">
          <CreateDerivative
            ref="derivmodal"
            rootwod={this.state.rootwod? this.state.rootwod: this.state.wod}
            wod={this.state.newwodderiv}
            handlecreatederiv={(newbudget) => {
              this.handlecreatederiv(newbudget);
            }}
          />

          <TMListModal
            wonum={this.state.wod.workOrderNbr}
            wod={this.state.wod}
            update
            tm
            status
            for
            enabling
            ref="tmlist"
            updateWodState={(tnms) => {
              console.log("TNM Status", tnms.length, tnms);

              this.setState({ tmstatus: tnms.length });
            }}
            custinfo={this.props.customers.find(
              (c) => c.custnumber === this.state.wod.custnumber
            )}
            wods={this.props.wods}
            tnmlist={wod.tmsheets}
            invlist={this.state.wod.invoices}
            similarwods={this.state.similarwods}
            updateinv={(invlist) => this.setState({ invlist })}
            showModal={this.props.modalstatus === "tmlist"}
            closemodal={() => this.props.handlemodal("none")}
          />
          <INVListModal
            wonum={this.state.wod.workOrderNbr}
            wod={this.state.wod}
            update
            tm
            ref="invlist"
            status
            for
            enabling
            invlist={this.state.wod.invoices}
            similarwods={this.state.similarwods}
            updateWodState={(invlist) => this.setState({ invlist })}
            showModal={this.props.modalstatus === "invlist"}
            closemodal={() => this.props.handlemodal("none")}
          />
          <MatEntryModal
            tab
            tnmlist={wod.tmsheets}
            invlist={invoices}
            wonum={wod.workOrderNbr}
            wod={this.state.wod}
            update={() => this.refreshWod()}
            ref="matmodal"
            mats={wod.dailymaterialentries}
          />
          <RelatedWods
            ref="relatedwods"
            wods={this.props.wods}
            wod={wod}
            similarwods={this.state.similarwods}
            updateWodState={(wodlist) =>
              this.setState({ similarwods: wodlist }, () =>
                console.log("similarwods", this.state.similarwods)
              )
            }
            findcustomer={(custnum) => {
              if (this.props.customers) {
                let custName = this.props.customers.find(
                  (cust) => cust.custnumber === custnum
                );

                if (custName) {
                  return custName.custname;
                } else {
                  return "N/A";
                }
              }
            }}
          />
          {this.genwodform(assignments, wod.tmsheets)}
          <Assignments
            wod={this.state.wod}
            handleNewAssignment={(newassignment) =>
              app
                .service("assign")
                .create({
                  ...newassignment,
                  assigned_task: this.state.wod.workOrderNbr,
                })
                .then(() => this.refreshWod())
            }
            assignments={assignments}
            refreshWod={() => this.refreshWod()}
          />
          <FileModal
            wod={this.state.wod}
            closemodal={() => this.props.handlemodal("none")}
            showModal={this.props.modalstatus === "filemodal"}
            deletefile={id => app.deletewodfile(id).then(() => this.refreshWod())}
            uploadFiles={(files) =>
              app
                .uploadWodFiles(this.state.wod.workOrderNbr, files)
                .then(() => this.refreshWod())
            }
            refreshWod={() => this.refreshWod()}
          />
        </div>
      );
    } else if (!this.state.wod && this.props.params.wonum) {
      return (
        <div>
          <h2>Loading Work Order...</h2>
        </div>
      );
    } else {
      return (
        <div>
          <p>Something Else</p>
        </div>
      );
    }
  }
}
function mapStateToProps(state) {
  return {
    locations: state.custinfo.locations,
    pms: state.custinfo.engassigned,
    invoices: state.invoices.all,
    tnms: state.tnms.all,
    billing: state.custinfo.billing,
    programs: state.custinfo.programs,
    assign: state.jobs.assignedjobs,
    access: state.myinfo.accessstatus,
    modalstatus: state.modal,
    customers: state.custinfo.customers,
    employees: state.employees.employees,
    wods: state.workorders.derivitives,
    jobs: state.jobs.assignedjobs,
    myinfo: state.myinfo.employeeinfo,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getpath: getpath,
      handlemodal: modalhandler,
      datapop: datapop,
    },
    dispatch
  );
}
export default connect(mapStateToProps, matchDispatchToProps)(WorkOrders);



// WEBPACK FOOTER //
// ./src/containers/WorkOrders.jsx